/*------------------------------------*\
    FORM VALIDATION
\*------------------------------------*/

WW.formValidator = function($) {

    const error = {
            empty: 'Var vänlig och fyll i alla obligatoriska fält',
            email: 'Var god fyll i en giltig e-postadress',
            phone: 'Var god fyll i ett giltigt telefonnummer'
        },


        isNumeric = (str) => {
            return !isNaN(parseFloat(str)) && isFinite(str);
        },


        isEmail = (str) => {
            const regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            return regex.test(str);
        },


        giveFeedback = (error, element) => {
            element.closest('li').find('.js-form-validation__status').text(error);
        },


        hasErrors = (value, type, required) => {
            return () => {
                if (value === '') {
                    if (required) {
                        return error.empty;
                    }
                } else if (type === 'email') {
                    if (!isEmail(value)) {
                        return error.email;
                    }
                } else if (type === 'tel') {
                    const val = value.replace(/[^\w\s]/gi, '');
                    if (!(isNumeric(val) && val.length > 4)) {
                        return error.phone;
                    }
                }
            };
        },


        handleRequest = (e) => {
            const form = $(e.target).closest('.js-form-validation'),
                inputs = form.find('.js-form-validation__input');

            inputs.each(function() {
                const el = $(this),
                    error = hasErrors(el.val(), el.attr('type'), el.prop('required'));

                if (error) {
                    el.addClass('c-text-input--error');
                    giveFeedback(error, el);
                    e.preventDefault();
                } else {
                    if (el.hasClass('c-text-input--error')) {
                        el.removeClass('c-text-input--error');
                    }
                    giveFeedback('', el);
                }
            });
        };


    $('.js-form-validation__submit').on('click', handleRequest);
    $('.js-form-validation__input').on('keyup focusout', handleRequest);

    return this;
};

//add .formValidator($) to main.js
